const mutations = {
    SET_ERROR_WAREHOUSES(state, payload) {
        state.error = payload;
    }
};

export default mutations;
